import { useCallback } from 'react'
import { InputType, Moment, MOMENT_SLUGS } from '@/constants'
import { useSessionStore } from '@/stores'
import { resolveMoment } from '../utils/sectionsConfig'
import { useOmpActions } from '../ompActions'

// The payment_issue flow: a declined charge is resolved by taking a new card
// (RebillItem), not by reactivating — the subscription was never cancelled.
export function usePaymentUpdateAction() {
  const { startAction } = useOmpActions()
  const session = useSessionStore(s => s.session) as any
  const isPaymentIssue = resolveMoment(session) === MOMENT_SLUGS[Moment.PaymentIssue]
  const item = session?.moment_item
  const available =
    isPaymentIssue && !!item && (session?.intents as number[] | undefined)?.includes(InputType.RebillItem) === true

  const start = useCallback(() => {
    const current = useSessionStore.getState().session as any
    const target = current?.moment_item
    if (!target) {
      return
    }
    startAction(target, InputType.RebillItem, 'Update Payment Method')
  }, [startAction])

  return { available, start }
}
